import { Box, Container, Typography } from '@mui/material';
import React from 'react';

import Footer from 'components/@footer/Footer';
import SEO from 'components/@head/SEO';
import NavigationHeader from 'components/@navigation/NavigationHeader';

interface SEO {
  meta_title?: string | null;
  meta_description?: string | null;
}

interface Props {
  title?: string | null;
  seo?: SEO;
  children: React.ReactNode;
}

const Layout = ({ title, children, seo }: Props) => {
  return (
    <>
      <SEO
        title={seo?.meta_title ?? undefined}
        description={seo?.meta_description ?? undefined}
      />
      <NavigationHeader hideCountry />
      <Box
        minHeight="calc(100vh - 80px)"
        bgcolor="background.default"
        pb={10}
        flex={1}
      >
        {title && (
          <Container sx={{ mt: { xs: 12, md: 25 } }} maxWidth="sm">
            <Typography mb={8} variant="h1" color="brand.red">
              {title}
            </Typography>
          </Container>
        )}
        {children}
      </Box>
      <Footer />
    </>
  );
};

export default Layout;
